import React from "react";
import RenderEmailTabs from "../RenderEmailTabs";

export default function ContactsTabLayout({ activeTab, setActiveTab }) {
  /* ******************** All States ************************* */

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div className="inbox-root d-flex" style={{ height: "100vh" }}>
      <>
        <aside
          className="bg-white border-end"
          style={{ minWidth: 300, width: "300px" }}
        >
          <div className="p-2">
            <RenderEmailTabs
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
        </aside>
      </>
      <main className="flex-grow-1 px-3 py-2">
        <div
          className="card custom-border-radius p-2"
          style={{
            height: "98vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div className="flex-center h-100">
            <h3>Contacts Tab Content</h3>
          </div>
        </div>
      </main>
    </div>
  );
}
